var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tag',{attrs:{"color":_vm.getColor()}},[_vm._v(_vm._s(_vm.getDate()))])
}
var staticRenderFns = []

export { render, staticRenderFns }